import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface SuccessPanelProps {
  caseNumber?: string | number;
}

export function SuccessPanel({ caseNumber }: SuccessPanelProps) {
  const { t } = useLanguage();
  return (
    <div className="px-6 py-8 text-center space-y-4">
      <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" />
      <h2 className="text-lg font-bold text-[#004250]">
        {t('landing.requestTreatment.successTitle')}
      </h2>
      <p className="text-sm text-muted-foreground">
        {t('landing.requestTreatment.successBody')}
      </p>
      {caseNumber !== undefined && (
        <p className="text-sm font-semibold">
          {t('landing.requestTreatment.successCaseLabel')}: {String(caseNumber)}
        </p>
      )}
      <Link to="/dashboard/customer" className="block">
        <Button className="w-full bg-[#7dda55] hover:bg-[#6bc748] text-white">
          {t('landing.requestTreatment.goToDashboard')}
        </Button>
      </Link>
    </div>
  );
}
